/**
 * A saúde do sync com o provider, do jeito que o app a lê:
 * `households/{hid}/syncHealth/{itemId}`, escrito pelo sync agendado e só
 * leitura para o cliente (`firestore.rules`).
 *
 * Existe desde 2026-10-18. De 11 a 18/10 a conexão do banco no Meu Pluggy
 * parou, o sync seguiu terminando em "item sincronizado", e ninguém soube por
 * uma semana — ver `Docs/07-Integracoes/Pluggy.md`, item 4.
 *
 * - `ok` — os dados estão chegando.
 * - `stale` — o provider responde, mas os DADOS pararam (mais de 36h; a régua
 *   está em `functions/src/pluggy/saude.ts`).
 * - `error` — a última rodada não conseguiu falar com o provider.
 */
export type SyncHealth = {
  itemId: string
  status: 'ok' | 'stale' | 'error'
  /** Instante ISO da última vez que o provider buscou os dados no banco. */
  dataUpTo: string | null
  /** Instante ISO em que o problema atual começou; `null` quando ok. */
  problemSince: string | null
  /** Instante ISO da última conferência. */
  checkedAt: string | null
}

const GRAVIDADE: Record<SyncHealth['status'], number> = { ok: 0, stale: 1, error: 2 }

/**
 * O aviso que o app mostra: o item mais grave — falha antes de parado, porque
 * falha é o que ninguém mais vai consertar sozinho na rodada seguinte. `null`
 * quando está tudo ok.
 */
export function avisoDoSync(itens: readonly SyncHealth[]): SyncHealth | null {
  const comProblema = itens.filter((i) => i.status !== 'ok')
  if (comProblema.length === 0) return null
  return [...comProblema].sort((a, b) => GRAVIDADE[b.status] - GRAVIDADE[a.status])[0] ?? null
}
